import { emptyError as commonEmptyError, createTestObjectArray, TEST_TEMPLATES } from "../../utility/common/TransactionComponents/TransactionValidationUtils";

export const emptyError = (err, seterr, iserror) => {
  return commonEmptyError(err, seterr, iserror);
};

export const SetErrorValueAValueB = (status,msg,Column,setErr,error) =>{
  setErr((prevState) => ({
    ...error,
    ...prevState,

    [Column]: [
      {
        Value_A: [
          {
            status: status,
            message: msg,
          },
        ],
      },
      {
        Value_B: [
          {
            status: status,
            message: msg,
          },
        ],
      },


    ],
  }));
}

export const createDetailObjPQR = (start, end) => {
  let temparray = []
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const formattedDate = `${day}-${month}-${year}`;

  for (let i = start; i <= end; i++) {
    temparray.push({
      SK: "",
      PK: "",
      wld_createdon: formattedDate,
      PQR_RecordNo: "",
      PQR_Process: "",
      PQR_Layer: "",
      // PQR_new:"",
      // PQR_Change: 0,
      PQR_Type: "",
      PQRD_FM_SFA: "",
      PQRD_FM_Classification: "",
      PQRD_FM_FNo: "",
      PQRD_FM_Ano: "",
      PQRD_FM_Nominal: "",
      PQRD_FM_TradeName: "",

      PQRD_FM_ProductForm: "",
      PQRD_FM_FillerMetalSize: [],
      PQRD_FM_DepositedThickness: "",
      PQRD_FM_MaxPassThickness: "",
      PQRD_FM_WeldDepositChemistry: "",
      PQRD_FM_FluxAWS: "",
      PQRD_FM_FluxNominalComposition: "",
      PQRD_FM_FluxTradeName: "",
      PQRD_FM_FluxType: "",
      PQRD_FM_FluxRecrushed: "",
      PQRD_FM_Supplement: "",
      PQRD_FM_FillerMetalOthers: "",

      PQRD_Position_PositionofGroove: [],
      PQRD_Position_WeldProgression: [],

      PQRD_Preheat_MinimumPreheatTemp: "",
      PQRD_Preheat_MaximumInterpassTemp: "",

      PQRD_Electrical_FillerMetalSize: [],
      PQRD_Electrical_Amperes: [],
      PQRD_Electrical_Volts: [],
      PQRD_Electrical_TravelSpeed: [],
      PQRD_Electrical_minBeadLength: [],
      PQRD_Electrical_ArcTransferMode: [],
      PQRD_Electrical_MaxHeatInput: [],
      PQRD_Electrical_TungstenType: [],
      PQRD_Electrical_CurrentPolarity: [],
      PQRD_Electrical_DCPulsatingCurrent: [],
      PQRD_Electrical_Others: "",
      PQRD_Electrical_WireFeedType: [],
      PQRD_Electrical_WireFeedSpeed: [],

      PQRD_Gas_ShieldingType: "",
      PQRD_Gas_ShieldingFlowRate: "",
      PQRD_Gas_BackingType: "",
      PQRD_Gas_BackingFlowRate: "",
      PQRD_Gas_TrailingType: "",
      PQRD_Gas_TrailingFlowRate: "",
      PQRD_Technique_StringOrWeave:"",
      PQRD_Technique_Orifice_GasCupSize:"",
      PQRD_Technique_CTWD:"",
      PQRD_Technique_Oscillation:"",
      PQRD_Technique_Multi_SingleElectrode:"",
      PQRD_Technique_ElectrodeAngle:"",
      PQRD_Technique_SinglePassPerSide:"",
      PQRD_Technique_Multiple_SingleLayer:"",
      PQRD_Technique_Peening:"",
      PQRD_Technique_InitialInterpassCleaning:"",
      PQRD_Technique_BackGaugingMethod:"",
      PQRD_Technique_Technique_Other:"",
      PQRD_Technique_GroovePreparation:"",
      PQRD_Technique_ElectrodesSamePuddle:"",
      PQRD_Technique_SupplimentalDevice:"",
      PQRD_Technique_Overlaping:"",
      showreport: false, // Default to true for new processes
    });
  }
  return temparray;
}

export const Tensile_Test_Obj = (start, end) => {
  return createTestObjectArray(end - start + 1, TEST_TEMPLATES.PQR_TENSILE_TEST);
};

export const GuidedBend_Test_Obj = (start, end) => {
  return createTestObjectArray(end - start + 1, TEST_TEMPLATES.PQR_GUIDED_BEND_TEST);
};



export const Toughness_Test_Obj = (start, end) => {
  return createTestObjectArray(end - start + 1, TEST_TEMPLATES.PQR_TOUGHNESS_TEST);
};

export const Other_Test_Obj = (start, end) => {
  return createTestObjectArray(end - start + 1, TEST_TEMPLATES.PQR_OTHER_TEST);
};
export const Other_Test_overlay_Obj = (start, end) => {
  return createTestObjectArray(end - start + 1, TEST_TEMPLATES.OTHER_TEST);
};
export const Certification_Obj = (start, end) => {
  return createTestObjectArray(end - start + 1, TEST_TEMPLATES.PQR_CERTIFICATION_SIMPLE);
};
export const CertificationLabRef_Obj = (start, end) => {
  return createTestObjectArray(end - start + 1, TEST_TEMPLATES.PQR_CERTIFICATION_LAB_REF);
};

export const GuidedBend_Test_Overlay_Obj = (start, end) => {
  return createTestObjectArray(end - start + 1, TEST_TEMPLATES.PQR_GUIDED_BEND_TEST_OVERLAY);
};